import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const WebhooksListRowSkeleton: FC = (): JSX.Element => {
  return (
    <div className="webhooks-list-row webhooks-list-row__grid-template mr-4">
      <div className="webhooks-list-row__element">
        <Skeleton width="40%" height={16} />
      </div>

      <div className="webhooks-list-row__element">
        <Skeleton width={40} height={16} />
      </div>

      <div className="webhooks-list-row__element flex-wrap">
        <Skeleton width="90%" height={16} />
        <Skeleton width="100%" height={16} />
        <Skeleton width="25%" height={16} />
      </div>

      <div className="webhooks-list-row__element">
        <Skeleton width={30} height={16} />
      </div>

      <div className="webhooks-list-row__element gap-20">
        <Skeleton width={50} height={30} style={{ borderRadius: 30 }} />
        <Skeleton width={25} height={25} />
      </div>
    </div>
  );
};

export default WebhooksListRowSkeleton;
